import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "../src/assets/scss/dart-sass/anti.css"
import "../src/assets/scss/dart-sass/main.scss"

import { AnimatePresence, motion } from "framer-motion"
import { Router } from "next/router"
import nProgress from "nprogress"
import { useEffect } from "react"
import TagManager from "react-gtm-module"
import { Helmet, HelmetProvider } from "react-helmet-async"
import Layout from "@components/global/Layout"
import SEO from "@components/global/SEO"

// NProgress Loading
nProgress.configure({ showSpinner: false })
Router.events.on("routeChangeStart", (url) => nProgress.start())
Router.events.on("routeChangeComplete", () => nProgress.done())
Router.events.on("routeChangeError", () => nProgress.done())

function MyApp({
  Component,
  pageProps = {
    page: "default",
    seo: { title: "Jaringan bioskop terbesar di Indonesia" },
    theme: "transparent",
  },
}) {
  // GTM **************************************************************************//
  useEffect(() => {
    if (TagManager.initialize) {
      TagManager.initialize({
        gtmId: process.env.GTM_ID,
      })
    }
  }, [])
  // GTM **************************************************************************//
  return (
    <HelmetProvider>
      <SEO
        title={pageProps?.seo?.title}
        description={pageProps?.seo?.description || ""}
      />
      <Helmet async>
        <body className={`bd-${pageProps?.page}`} />
      </Helmet>
      <AnimatePresence mode="wait">
        <motion.div
          key={pageProps?.page}
          className={`layout-${pageProps?.page}`}
          initial={{ opacity: 0.1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.1 }}
          transition={{ duration: 0.5 }}
        >
          <Layout theme={pageProps?.theme} page={pageProps.page}>
            <Component {...pageProps} />
          </Layout>
        </motion.div>
      </AnimatePresence>
    </HelmetProvider>
  )
}

export default MyApp
